import React, { Component } from "react";
import { NavLink } from "react-router-dom";

/**
 * Application Header component with branding and navigation toggle
 * Simplified header with just branding and navigation
 */
export class Header extends Component {
  render() {
    return (
      <header>
        <div className="navbar navbar-dark bg-primary">
          <div className="container d-flex justify-content-between">
            <NavLink
              to="/"
              className="navbar-brand d-flex align-items-center"
              aria-label="React Features Demo Home"
            >
              <div className="brand-icon mr-3">
                <i className="fab fa-react fa-2x text-light"></i>
              </div>
              <div>
                <strong className="h4 mb-0 text-white">React Features</strong>
                <br />
                <small className="text-light">HOC Demo</small>
              </div>
            </NavLink>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;